import { render } from "./viewGradeTypePop.vue?vue&type=template&id=6a04557b&scoped=true"
import script from "./viewGradeTypePop.vue?vue&type=script&lang=js"
export * from "./viewGradeTypePop.vue?vue&type=script&lang=js"

import "./viewGradeTypePop.vue?vue&type=style&index=0&id=6a04557b&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a04557b"]])

export default __exports__